import Navbar from "../../components/Navbar";
import Header from "../../components/Header";
import Features from "../../components/Features";
import Banner from "../../components/Banner";
import Introduction from "../../components/Introduction";
import Pricing from "../../components/Pricing";
import GetStarted from "../../components/GetStarted";
import Footer from "../../components/Footer";

const Landing = () => {
    return (
        <>
            <Navbar/>
            <Header/>
            <Features/>
            <Banner/>
            <Introduction/>
            <Pricing/>
            <GetStarted/>
            <Footer/>
        </>
    )
}

export default Landing;